var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.text1))])])]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content_center"},[_c('h3',[_vm._v(_vm._s(_vm.article.title))]),_c('h4',[_vm._v("—— "+_vm._s(_vm.article.date)+" ——")]),_c('article',{domProps:{"innerHTML":_vm._s(_vm.article.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }